import React, { useState, useEffect } from 'react';
import { Container, Table, Badge, Form, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import api from '../services/api';

const Tenders = () => {
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    loadTenders();
  }, [statusFilter]);

  const loadTenders = async () => {
    try {
      const params = statusFilter ? { status: statusFilter } : {};
      const response = await api.get('/tenders/', { params });
      setTenders(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading tenders:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-4">Tenders</h1>
      
      <Row className="mb-4">
        <Col md={4}>
          <Form.Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">All Tenders</option>
            <option value="open">Open</option>
            <option value="closed">Closed</option>
            <option value="awarded">Awarded</option>
            <option value="cancelled">Cancelled</option>
          </Form.Select>
        </Col>
      </Row>

      <div className="table-responsive">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Tender No.</th>
              <th>Title</th>
              <th>Department</th>
              <th>Submission Deadline</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tenders.map(tender => (
              <tr key={tender.id}>
                <td>{tender.tender_no}</td>
                <td>{tender.title}</td>
                <td>{tender.department_name}</td>
                <td>{moment(tender.submission_deadline).format('MMM DD, YYYY')}</td>
                <td>
                  <Badge bg={
                    tender.status === 'open' ? 'success' :
                    tender.status === 'closed' ? 'secondary' :
                    tender.status === 'awarded' ? 'primary' : 'danger'
                  }>
                    {tender.status}
                  </Badge>
                </td>
                <td>
                  <Link to={`/tenders/${tender.slug}`} className="btn btn-sm btn-primary">
                    View Details
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default Tenders;
